import { Routes } from '@angular/router';
import { IndexComponent } from './app/pages/index/index.component';
import { AppManagementLayout } from './app/layout/component/management.layout';
import { LoginComponent } from './app/pages/login/login.component';
import { NotFoundComponent } from './app/pages/notfound/notfound.component';
import { AuthGuard } from './app/helper/guards/auth.guard';
import { AdminGuard } from './app/helper/guards/admin.guard';
import { AppHomeLayout } from './app/layout/component/home.layout';

export const appRoutes: Routes = [
    {
        path: '',
        component: IndexComponent,
        data: { title: 'footer.title' }
    },

    {
        path: 'login',
        component: LoginComponent,
        data: { title: 'auth.login' }
    },

    {
        path: 'home',
        component: AppHomeLayout,
        loadChildren: () => import('./app/modules/home/home.routes'),
        canActivate: [AuthGuard]
    },
    {
        path: 'admin',
        component: AppManagementLayout,
        loadChildren: () => import('./app/modules/management/management.routes'),
        canActivate: [AdminGuard]
    },
    {
        path: 'notfound',
        component: NotFoundComponent,
        data: { title: 'common.pageNotFound' }
    },
    { path: '**', redirectTo: '/notfound' }
];
